import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, inject, onActivated } from "vue";
import dayjs from "dayjs";
import {
  PROVIDE_KEY_REMOVE_LOADING_IMAGE,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_LOADING_IMAGE,
  RemoveLoadingImage,
  RouterName,
  ShowErrorModal,
  ShowLoadingImage,
} from "@/types";
import Page from "@/components/shared/Page.vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import Calendar from "@/components/shared/Calendar.vue";
import { useBoardStore } from "@/stores/boardStore";
import { IBoardInfo } from "@/domain/entities/board";
import BoardHistoryTable from "@/components/board/BoardHistoryTable.vue";
import router from "@/router";


const __default__ = {
  name: "BoardHistory",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showLoadingImage = inject(
  PROVIDE_KEY_SHOW_LOADING_IMAGE
) as ShowLoadingImage;
const removeLoadingImage = inject(
  PROVIDE_KEY_REMOVE_LOADING_IMAGE
) as RemoveLoadingImage;

const boardStore = useBoardStore();

// 검색 범위 한계 설정 (오늘 일자로부터 1년 전까지만 선택 가능)
const limitFromBoardDate = ref(
  dayjs().subtract(1, "year").format("YYYY-MM-DD")
);
const limitEndBoardDate = ref(dayjs().format("YYYY-MM-DD"));

// 검색 범위 설정 변수
const searchFromDate = ref(dayjs().subtract(1, "month").format("YYYY-MM-DD"));
const searchToDate = ref(dayjs().format("YYYY-MM-DD"));

/** 달력 */
const shouldShowFromDateCalendar = ref(false);
const shouldShowToDateCalendar = ref(false);

const showFromDateCalendar = () => {
  shouldShowFromDateCalendar.value = true;
};

const showToDateCalendar = () => {
  shouldShowToDateCalendar.value = true;
};

const onSelectFromDate = (dateStr: string) => {
  shouldShowFromDateCalendar.value = false;
  const fromDay = dayjs(dateStr);
  const endDay = dayjs(searchToDate.value);

  if (fromDay > endDay) {
    searchToDate.value = dateStr;
  }
  searchFromDate.value = dateStr;
  getBoardingHistory();
};

const onSelectToDate = (dateStr: string) => {
  shouldShowToDateCalendar.value = false;
  const fromDay = dayjs(searchFromDate.value);
  const endDay = dayjs(dateStr);

  if (fromDay > endDay) {
    const getMonthAgo = dayjs(dateStr)
      .subtract(1, "month")
      .format("YYYY-MM-DD");
    searchFromDate.value = getMonthAgo;
  }
  searchToDate.value = dateStr;
  getBoardingHistory();
};

// 탑승 내역 목록 가져오기
const boardHistory = ref<IBoardInfo[]>([]);
const isGetBoardHistory = ref(false);

const shouldShowEmptyContent = computed(() => {
  return !boardHistory.value.length && isGetBoardHistory.value;
});

const getBoardingHistory = async () => {
  showLoadingImage();
  const boardHistoryResult = await boardStore.getBoardingHistory(
    searchFromDate.value,
    searchToDate.value,
    "realOnDtm desc"
  );
  removeLoadingImage();

  isGetBoardHistory.value = true;
  if (!boardHistoryResult.isSuccess) {
    showErrorModal(
      "탑승내역 오류",
      boardHistoryResult.errorMessage,
      boardHistoryResult.resultCode,
      boardHistoryResult.errorTime
    );
  }

  boardHistory.value = boardHistoryResult.data || [];
};

// 탑승내역 상세 화면 보여주기
// const shouldShowBoardHistoryDetail = ref(false);
// const toggleShowBoardHistoryDetail = (show: boolean) => {
//   shouldShowBoardHistoryDetail.value = show;
// };

// const onCompleteSurvey = () => {
//   toggleShowBoardHistoryDetail(false);
//   getBoardingHistory();
// };

// const selectedBoardInfo = ref<IBoardInfo>();
// const showBoardHistoryDetail = (boardInfo: IBoardInfo) => {
//   selectedBoardInfo.value = boardInfo;
//   // shouldShowBoardHistoryDetail.value = true;
//   goToBoardEvaluation(boardInfo.lineTurnUid, boardInfo.allocUid);
// };

const goToBoardEvaluation = (
  lineTurnUid: string,
  allocUid: string,
  lineTypeCode: string,
  lineName: string,
  campusName: string
) => {
  router.push({
    name: RouterName.BoardEvaluation,
    query: {
      lineTurnUid,
      allocUid,
      lineTypeCode,
      lineName,
      campusName,
    },
  });
};

const showBoardHistoryDetail = (boardInfo: IBoardInfo) => {
  // goToBoardEvaluation(
  //   boardInfo.lineTurnUid,
  //   boardInfo.allocUid,
  //   boardInfo.lineTypeCode,
  //   boardInfo.lineRouteName,
  //   boardInfo.campusName
  // );
};

onActivated(() => {
  getBoardingHistory();
});

const __returned__ = { showErrorModal, showLoadingImage, removeLoadingImage, boardStore, limitFromBoardDate, limitEndBoardDate, searchFromDate, searchToDate, shouldShowFromDateCalendar, shouldShowToDateCalendar, showFromDateCalendar, showToDateCalendar, onSelectFromDate, onSelectToDate, boardHistory, isGetBoardHistory, shouldShowEmptyContent, getBoardingHistory, goToBoardEvaluation, showBoardHistoryDetail, Page, NavigationBar, Calendar, BoardHistoryTable }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})